import { useEffect, useRef } from "react";
import Hls from "hls.js";

/**
 * M3U8Player
 * @param {string}  src       - M3U8 stream URL
 * @param {string|number} width  - CSS width  (e.g. "100%", 640)
 * @param {string|number} height - CSS height (e.g. "360px", 360)
 * @param {boolean} autoplay  - Start playback automatically once loaded (default: false)
 */
export default function M3U8Player({ src, width, height, autoplay = false }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) return;

    let hls;

    if (Hls.isSupported()) {
      hls = new Hls({ autoStartLoad: true });
      hls.loadSource(src);
      hls.attachMedia(video);

      if (autoplay) {
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play().catch(() => {});
        });
      }
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      // Native HLS (Safari)
      video.src = src;
      if (autoplay) {
        video.addEventListener("loadedmetadata", () => {
          video.play().catch(() => {});
        });
      }
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [src, autoplay]);

  return (
    <video
      ref={videoRef}
      width={width}
      height={height}
      controls
      style={{ display: "block", backgroundColor: "#000" }}
    />
  );
}
